import { PublicClientApplication } from '@azure/msal-browser';

export default (config) => {
  return new PublicClientApplication(config);
};
